import React from 'react';
import { SubscriptionData } from '../BillingTypes';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'services/settings/SettingsContext';
import { calculateCurrentSubscriptionAmount } from '../functions/billingUtils';

interface StartInvoiceCardProps {
    loading: string;
    subscription: SubscriptionData,
};

const StartInvoiceCard: React.FC<StartInvoiceCardProps> = ({ loading, subscription }) => {
    const { t } = useTranslation();
    const { userLocale } = useSettings();

    // Get the start invoice amount
    const getStartInvoiceAmount = (subscription: SubscriptionData) => {

        // Initialize the invoice amount variable
        let invoiceAmount;

        // Calculate the invoice amount based on the current subscription
        if (subscription.subscription_lines) {
            invoiceAmount = calculateCurrentSubscriptionAmount({
                subscription_lines: subscription.subscription_lines, 
                displayPrice: subscription.duration, 
                returnAmount: 'totalInclVat', 
                userLocale
            });
        };

        return invoiceAmount;
    };

    return (
        <div className='card next-invoice'>
            <h6>{t('billing.general.start_invoice_label')}</h6>
            {loading === 'show-loader' ? (
                <div className="loader"></div>
            ) : loading === 'success' && (
                <div className='next-invoice-details'>
                    <div className=''>
                        <p>{t('billing.general.next_invoice_estimated_price_label')}</p>
                    </div>
                    <div className='price-big'>
                        € {getStartInvoiceAmount(subscription)}
                    </div>
                </div>
            )}
        </div>
    )
};

export default StartInvoiceCard;